import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select'
import { useLocale, type Locale } from '../contexts/LocaleContext'

interface LocaleSelectorProps {
    value?: string
    onChange?: (value: string) => void
    disabled?: boolean
}

const languages = [
    { code: 'en' as Locale, name: 'English', flag: '🇺🇸' },
    { code: 'fr' as Locale, name: 'Français', flag: '🇫🇷' }
]

export function LocaleSelector({ value, onChange, disabled }: LocaleSelectorProps) {
    const { locale, setLocale } = useLocale()

    const currentValue = value ?? locale
    const handleChange = onChange ?? ((v: string) => setLocale(v as Locale))

    const selectedLanguage = languages.find(lang => lang.code === currentValue) || languages[0]

    return (
        <Select value={currentValue} onValueChange={handleChange} disabled={disabled}>
            <SelectTrigger className="w-full">
                <SelectValue>
                    <div className="flex items-center gap-2">
                        <span className="text-lg">{selectedLanguage.flag}</span>
                        <span>{selectedLanguage.name}</span>
                    </div>
                </SelectValue>
            </SelectTrigger>
            <SelectContent>
                {languages.map((language) => (
                    <SelectItem key={language.code} value={language.code}>
                        <div className="flex items-center gap-2">
                            <span className="text-lg">{language.flag}</span>
                            <span>{language.name}</span>
                        </div>
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    )
}
